export enum Permission {
  RetailerFundedMarketingViewAccess = 'retailer_funded_marketing.view',
  RetailerFundedMarketingModifyAccess = 'retailer_funded_marketing.modify',
  RetailerFundedMarketingBillingView = 'retailer_funded_marketing_billing.view',
  RetailerFundedMarketingBillingModifyAccess = 'retailer_funded_marketing_billing.modify',
  RetailerFundedMarketingInsights = 'retailer_funded_marketing.insights',
}
